import { render, staticRenderFns } from "./single_thread.vue?vue&type=template&id=639f430f&scoped=true"
import script from "./single_thread.vue?vue&type=script&lang=js"
export * from "./single_thread.vue?vue&type=script&lang=js"
import style0 from "./single_thread.vue?vue&type=style&index=0&id=639f430f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f430f",
  null
  
)

export default component.exports